import React, { useEffect, useRef, useState } from "react";
import UserRoutes from "../routes/UserRoutes";
import { Route, Routes } from "react-router-dom";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

const UserLayout = () => {
    const outsideClickRef = useRef(null);
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const [isMobileView, setIsMobileView] = useState(false);

    const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
    const closeSidebar = () => setSidebarOpen(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 1024);
        };
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleOutSideClick = (e) => {
            if (!outsideClickRef.current?.contains(e.target)) {
                setSidebarOpen(false);
            }
        };

        window.addEventListener("mousedown", handleOutSideClick);

        return () => {
            window.removeEventListener("mousedown", handleOutSideClick);
        };
    }, [outsideClickRef]);

    return (
        <div id="root">
            <div className={`main-content`}>
                <Navbar toggleSidebar={toggleSidebar} />
                {isMobileView && <Sidebar isSidebarOpen={isSidebarOpen} closeSidebar={closeSidebar} />}
                <Routes>
                    {UserRoutes.map((prop) => (
                        <Route path={prop.path} element={prop.element} key={prop.path} />
                    ))}
                    <Route path="*" element={<div>Not Found</div>} />
                </Routes>
            </div>
            <Footer />
        </div>
    );
};

export default UserLayout;